import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { CancelPaymentProcessRequestDto } from './dto/request/cancel-payment-process.request.dto';

const USERS_PATH = HttpPathsEnum.USERS;

class PaymentManagementApi {
  public async cancelPaymentProcess(data: CancelPaymentProcessRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/payment/cancel-payment`,
      method: RequestType.POST,
      data,
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }
}

export default new PaymentManagementApi();
